module.exports = __webpack_public_path__ + "static/media/38 - Chaka Khan - Fate (WSM Compilation Edit).18d70520.mp3";